<div class="container-fluid">
  <!-- start page title -->
  <div class="row">
    <div class="col-12">
        <div class="page-title-box">
            <div class="page-title-right">
              <a class="btn btn-primary" (click)="volver()">
                Volver
              </a>
            </div>
            <h3 class="page-title">
              <div class="row">
                <div class="col-12">Organización: <span style="color: #016E97;">{{organizacion}}</span></div>
              </div>
              <div class="row" style="margin-top: -25px;">
                <div class="col-12">Sucursal: <span style="color: #016E97;">{{sucursal}}</span></div>
              </div>
            </h3>
        </div>
    </div>
  </div>

  <div class="row" style="overflow-x: scroll;">
    <div class="col-12">
      <div class="card" style="border-color: white;">
        <div class="card-body" style="margin-bottom: 150px;">
          <!-- Invoice Logo-->
          <div class="row">
            <div class="col-md-6">
              <label for="estadol" class="col-form-label">Busqueda</label>
              <input
                class="form-control"
                type="text"
                id="buscar"
                placeholder="Buscar organización..."
                [(ngModel)]="searchTerm"
                (input)="buscarAspirante()"
              >
            </div>
          </div>

          <hr class="text-dark">
          <div class="row">
            <div class="col-12">

              <table class="table">
                <thead>
                  <tr class="table-primary">
                    <th scope="col">N°</th>
                    <th scope="col">Aspirante</th>
                    <th scope="col">Género</th>
                    <th scope="col">Estado</th>
                    <th scope="col">Fecha de Registro</th>
                    <th scope="col">O.C Seleccionadas</th>
                    <th scope="col">Aprobado/Rechazado</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let r of filteredResultado; let i = index">
                    <th scope="row">{{i+1}}</th>
                    <td>{{r.aspirante}}</td>
                    <td>{{r.genero}}</td>
                    <td>{{r.estado}}</td>
                    <td>{{r.fecha_registro}}</td>
                    <td><a style="cursor: pointer;" class="btn btn-sm btn-primary" (click)="seleccionOcupacion(r.id_participante)">Mostrar</a></td>
                    <td class="text-center">
                      <input style="width: 2em; height: 2em; border: 4px solid #313131;"
                             class="form-check-input"
                             type="checkbox"
                             id={{r.id_participante}}
                             value={{r.id_participante}}
                             name="participantes">
                    </td>
                  </tr>
                </tbody>
              </table>


            </div>
          </div>

          <div class="row mt-3">
            <div class="col-md-12 text-center">
              <a style="cursor: pointer;" class="btn btn-lg btn-primary" (click)="cargar()">Aceptar</a>
            </div>
          </div>

        </div> <!-- end card-body-->
      </div> <!-- end card -->
    </div> <!-- end col-->
  </div>


</div>


<app-modal [titulo]="titulo" [tipo_color]="tipo_color" [letra_color]="letra_color" [mensaje]="mensaje"></app-modal>
